export default __webpack_public_path__ + "static/media/Malwa.39648508.jpg";